@use "../../variables" as *;
@use "../../mixins" as *;

.separator {
  @include separator-bottom;
}

.size-container {
  padding: .75rem;

  @include desktop {
    margin: 1rem 0 1rem 0;
    padding: 0;
  }

  .size-title {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $grey-text;
    font-size: 1.125rem;
    font-weight: 400;

    @include desktop {
      font-size: 1.25rem;
      font-weight: 300;
    }
  }

  .toggle-arrow {
    margin-left: auto;
    font-size: 1rem;
  }

  .details {
    margin: 1.125rem 0;
    font-size: 1rem;

    @include desktop {
      margin-top: 1.75rem;
      font-size: 1.125rem;
    }
  }
}